"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRUtil = exports.TUsers = exports.TTMS = exports.TRoster = exports.TRost = exports.TPayrollC = exports.TPayroll = exports.TAgents = exports.TLLM = exports.TKB = exports.THR = exports.TBillC = exports.TBill = exports.t = exports.twMerge = void 0;
var tailwind_merge_1 = require("tailwind-merge");
Object.defineProperty(exports, "twMerge", { enumerable: true, get: function () { return tailwind_merge_1.twMerge; } });
__exportStar(require("./benchmark"), exports);
__exportStar(require("./dates"), exports);
__exportStar(require("./fsm-data"), exports);
__exportStar(require("./meta-types"), exports);
__exportStar(require("./mimes"), exports);
__exportStar(require("./multi-map"), exports);
__exportStar(require("./rand"), exports);
__exportStar(require("./strings"), exports);
__exportStar(require("./tailwind"), exports);
__exportStar(require("./time"), exports);
exports.t = __importStar(require("./typebox"));
exports.TBill = __importStar(require("./types-billing"));
exports.TBillC = __importStar(require("./types-billing-nodate"));
exports.THR = __importStar(require("./types-hr"));
exports.TKB = __importStar(require("./types-kb"));
__exportStar(require("./types-llm"), exports);
exports.TLLM = __importStar(require("./types-llm-2"));
exports.TAgents = __importStar(require("./types-agents"));
exports.TPayroll = __importStar(require("./types-payroll"));
exports.TPayrollC = __importStar(require("./types-payroll-nodate"));
__exportStar(require("./types-reports"), exports);
exports.TRost = __importStar(require("./types-roster"));
exports.TRoster = __importStar(require("./types-roster-server"));
exports.TTMS = __importStar(require("./types-tms"));
exports.TUsers = __importStar(require("./types-users"));
__exportStar(require("./util"), exports);
exports.HRUtil = __importStar(require("./hr-util"));
//# sourceMappingURL=index.js.map